export const externalPathToFilter = ['login', 'forgotPassword', 'oneTimePassword', 'register'];
